import {Screens, DocTypes} from "userform/utils";
import {Flags} from "reducers/flagActions";
export interface IAuth {
  existing: boolean;
  roles: string[];
  userId: number;
  email?: string;
}
export interface IValidation {
  status: boolean;
  type: string;
  msg: string;
}
export interface INomiee {
  name: string;
  relationShip: string;
  dob: number;
  mobile: string;
}
export interface ICompanyInfo {
  id: string;
  fields: {
    cin: string;
    name: string;
    state: string;
    type: string;
  };
}

export interface IAlternateAddress {
  house: string;
  street: string;
  locality: string;
  landmark: string;
  pincode: string;
}

export interface IProfile {
  name: string;
  panNumber: string;
  dob: number;
  gender: string;
  mobile: string;
  mobileOtpVerified: boolean;
  address: IAddress;
  permAddress: IAddress;
  workAddress: IAddress;
  alternateAddresses: IAlternateAddress[];
  addressLine: string;
  addressPincode: number;
  permAddressPincode: string;
  residentType: string;
  resTenure: Date|number;
  resRentMonthly: number;
  livingWith: string;
  residentTypePerm: string;
  mothersName: string;
  fatherOrSpouseName: string;
  relationshipStatus: string;
  education: string;
  currentEmployer: string;
  employerType: string;
  employeeId: string;
  designation: string;
  duration: Date|number;
  workEmail: string;
  workEmailVerified: boolean;
  workDomainWhoIs: any;
  workAddressLine: string;
  workAddressPincode: string;
  workExperienceMonths: number;
  financeBasicInfo: IFinanceBasicInfo;
  assets: IAssets[];
  currentLoans: ICurrentLoans[];
  loanRequest: ILoanInfo;
  familyIncome: IFamilyIncome[];
  workCin: string;
  userId?: number;
  references: IReference[];
  alternateMobileNumbers: string[];
  nominees: INomiee[];
  bankAccounts: IBankAccounts[];
  utm_source?: string;
  }
export interface IInsuranceInputField {
  label: string;
  name: string;
  type: string;
  max_length: string | number;
  min: number;
  max: number;
  regex: string;
  options: Array<{name: string, value: string}>;
  value: string | number;
}
enum AccountType {
  SAVINGS = "SAVINGS",
  CURRENT = "CURRENT",
  LOAN = "LOAN",
}
export enum PurposeType {
  NACH = "NACH",
  DISBURSAL = "DISBURSAL",
}
export interface IBankAccounts {
  beneficiaryName?: string;
  bankName: string;
  ifsc: string;
  accountNumber: string;
  accountType?: AccountType;
  purposeType?: PurposeType;
}
export interface ILoanEligibilityCriteria {
  minSalaryCutoff: number;
  minAgeInMonthsCutoff: number;
  maxAgeInMonthsCutoff: number;
}
export interface IUserStatus {
  profileStatus: IProfile;
  googleStatus: IGoogleStatus;
  bankStatementsStatus: IBankStatementStatus;
  aadhaarStatus: IAadhaarStatus;
  isServiceable: boolean;
  sourcingCodes: string[];
  loanAmountTenure: ILoanAmountTenure;
  latestApplicationsStatus: ILatestLoanApplicationStatus;
  disbursedLoanStatus: IDisbursedLoan[];
  initialLoginChannel: LoginChannel;
  isTruecallerVerified: boolean;
  loanEligibilityCriteria: ILoanEligibilityCriteria;
  dashboardStatus: any;
}
export interface IRepaymentDetail {
  date: Date;
  interest: number;
  principal: number;
  balance: number;
  paidDate: number;
}
export interface IDisbursedLoan {
  amount: number;
  brokenInterest: number;
  closedDate: Date;
  disbursalDate: Date;
  dpd: number[];
  emiAmount: number;
  emiStartDate: Date;
  interestPercentage: number;
  nachStatus: string;
  processingFee: number;
  repaymentAccountDetails: any;
  showPaids: boolean;
  status: string;
  tenureMonths: number;
  repaymentSchedule: IRepaymentDetail[];
}

export interface IReference {
  referenceName: string;
  referenceMobile: string;
  referenceEmail: string;
  referenceRelation: string;
}

export interface ILoanApplicationInfo {
  id: number;
  amount: number;
  tenureMonths: number;
  createdTime: number;
  latestStatusUpdateTime: number;
  status: string;
  initiatedProgressPercent: number;
  subStatuses: string[];
  lenderOpportunityId: string;
  documentationModes: any;
  requiredPhysicalDocs: any;
  productType: string;
}

export interface ILatestLoanApplicationStatus {
  allowNewApplication: boolean;
  loanApplicationInfo: any;
  loanApprovalInfo: ILoanApprovalInfo;
  isDocModeAssigned: boolean;
  loanDisbursalInfo: IDisbursedLoan;
}

export interface IUTMParams {
  source: string;
  medium: string;
  campaign: string;
}

export interface ILoanAmountTenure {
  maxAmount: number;
  minAmount: number;
  tenureMonths: number[];
  interestRate: number;
  maxTenureByAmount: any;
}

export interface ILoanInfo {
  amount: number;
  tenure: number;
  purpose: string;
  purposeRemark: string;
  additionalLoanInfo: any;
}

export interface IAadhaarStatus {
  kycDone: boolean;
  qrDone: boolean;
  aadhaarNumber: string;
}
export interface IGoogleStatus {
  status: boolean;
}
export interface IBankStatementStatus {
  available: any;
  pending: string[];
  allowBsUpload: boolean;
}

export interface ICurrentLoans {
  loanType: string;
  loanAmount: number;
  loanEndDate: Date|number;
  loanEmi: number;
}

export interface IAddress {
  house: string;
  street: string;
  locality: string;
  landmark: string;
  pincode: string;
}

export interface IAssets {
  assetType: string;
  assetValue: number;
  location: string;
}

export interface IFinanceBasicInfo {
  netMonthlyIncome: number;
  creditLimit: number;
  numDependents: number;
  salaryMode: SalaryMode;
  employmentType: EmploymentType;
  totalCurrentEmi: number;
}
export interface IFamilyIncome {
  name: string;
  relation: string;
  age: number;
  income: number;
}

export interface IReduxAction<A> {
  type?: A;
}

export interface IDocument {
  image?: string;
  body?: string;
  type: DocTypes;
  version?: string;
  date?: Date;
  ext?: string;
  name?: string;
  contentType?: string;
}

export interface IReference {
  referenceType: string;
  referenceName: string;
  referenceMobile: string;
  referenceEmail: string;
}

export interface IDocUploadBody {
  contentType: string;
  content: string;
  applicationId?: number;
  name: string;
}

export interface IDocDetails {
  docSubType?: string;
  contentType: string;
  userId: number;
  docMode: string;
  docType: string;
  imageB64: string;
}

export enum BankStatementStatus {
  AVAILABLE = "AVAILABLE",
  PROCESSING = "PROCESSING",
  EXPIRED = "EXPIRED",
}

export interface IMenuLinks {
  title: string;
  screen: Screens;
  flag: Flags;
  completed: boolean;
}

export enum SalaryMode {
  BANK_TRANSFER = "BANK_TRANSFER",
  CHEQUE = "CHEQUE",
  CASH = "CASH",
}

export enum EmploymentType {
  SALARIED = "SALARIED",
  SELF_EMPLOYED = "SELF_EMPLOYED",
}

export interface IMarketingTrackingParams {
  gclId?: string;
  fbclId?: string;
}

export interface IActiveConsent {
 consent: boolean;
 comment: string;
}

export enum DocAppointmentLocationType {
  OFFICE = "OFFICE",
  RESIDENCE = "RESIDENCE",
}

export enum DocumentationMode {
  ESIGN = "ESIGN",
  DIGITAL = "DIGITAL",
  AGENCY = "AGENCY",
}

export interface IDocAppointment {
  userId: number;
  locationType: DocAppointmentLocationType;
  documentationMode: DocumentationMode;
  appointmentTime: number;
  requiredPhysicalDocs: IPhysicalDocs[];
}

export interface IPhysicalDocs {
  physicalDocType: string;
  requiredNo: number;
  isRequired: boolean;
  description: string;
}
export interface IDocumentsConsentStatus {
  isChequeAvailable: null;
  isNachUploaded: null;
}
export enum NACHStatus {
  ACTIVATED = "ACTIVATED",
  IN_PROCESS = "IN_PROCESS",
  REJECTED = "REJECTED",
  AUTHORIZED = "AUTHORIZED",
}
export interface INach {
  nachStatus: NACHStatus;
  activatedAt: number;
  authorizedAt: number;
  enachAuthLink: string;
  pnachLink: string;
  customer_id: string;
  mode: "ENACH" | "PNACH";
  order_id: string;
  vendor: string;
}
export interface ILoanApprovalInfo {
  amount; number;
  tenureMonths: number;
  interestPercent: number;
  processingFee: number;
  emiAmount: number;
  docAppointment: IDocAppointment;
  documentationModes: DocumentationMode[];
  requiredPhysicalDocs: IPhysicalDocs[];
  documentsConsentStatus: IDocumentsConsentStatus;
  lenderOpportunityId: string;
  isShubhSignRequired: boolean;
  isEsignDone: boolean;
  isCustomerSignatureRequired: boolean;
  nach: INach;
  productCode: string;
  esignRequestId: string;
  lenderId: number;
  dueDayOfMonth?: number;
  convenienceFee?: number;
  convenienceFeeGst?: number;
  convenienceFeePct?: number;
  minConvenienceFee?: number;
  status: string;
  subStatuses: string[];
}
export interface IRepaymode {
  mode: string;
}
export interface IProcessModes {
  Repayment: IRepaymode[];
  KYC: object[];
}

export interface IConsentProcessMode {
  processModes: IProcessModes;
}

interface IContent {
  image: string;
  description: string;
}
interface IInsurancePolicyDetails {
  tabLabel: string;
  content: IContent[];
}

export interface IInsuranceSubProducts {
  productPrice: number;
  title: string;
  icon: string;
}
export interface IInsuraceProduct {
  productId: string;
  subCategory: string;
  productPrice: number;
  productTitle: string;
  coverage: string;
  cost: string;
  displayImage: string;
  heading: string;
  details: string;
  validity: string;
  campaignName: string;
  productName: string;
  policyCovers: IInsurancePolicyDetails[];
  inputFields: IInsuranceInputField[];
  sumInsured: number;
  subCategoryCovers: {description: string, displayImage: string};
  termsAndCondition: string;
  coverType: {type: string, label: string, coveredMembers: []};
  insurer: {name: string, displayImage: string};
  distributor: {name: string, displayImage: string, secondaryText: string};
  declarationFields: [];
  isIndividual: boolean;
}
export interface IInsuranceOrder {
  orderId: string;
  userId: number;
  distributorName: string;
  status: string;
  policyId: string;
  productName: string;
  validityInMonths: number | string;
  policyNumber: number | string;
}

export interface ISubscriptionError {
  status: boolean;
  msg: [];
}

export interface IBuyPrice {
  applicable_tax: number;
  current_price: number;
  rate_id: number;
  rate_validity: string;
}
export interface ISellPrice {
  current_price: number;
  rate_id: number;
  rate_validity: string;
}
export interface IGoldProductDetails {
  brand: string;
  certification_type: string;
  description: string;
  dimensions: string;
  estimated_delivery_days: string;
  highlights: string[];
  id: number;
  images: string[];
  in_stock: boolean;
  making_charges: string;
  metal_stamp: string;
  metal_type: string;
  metal_weight: string;
  packaging_type: string;
  purity: string;
  quantity: number;
  refund_policy: string;
  sku_number: string;
  thickness: string;
  videos: string[];
}
export interface IGoldBalance {
  gold_balance: string;
}
export interface IPincodeDetails {
  city: string;
  is_valid: boolean;
  pincode: number;
  state: string;
}
export interface IRedeemGoldDetails {
  estimated_delivery_days: string;
  price: string;
  txn_id: number;

}
export interface ITransactionDetails {
  amount: number;
  created_at: number;
  paid_at: number;
  payment_mode: string;
  rate: number;
  quantity: number;
  payment_status: string;
  transaction_id: string;
  txn_status: string;
  type: string;
  vendor: string;
  vendor_id: string;
  vendor_invoice_id: string;
  _id: string;
}
export interface IGoldTransactions {
  gold_amount: string;
  price: string;
  rate: string;
  transaction_id: number;
  txn_date: string;
  type: string;
}
export interface IDeliveryStatus {
  courier_company: string;
  courier_tracking_id: string;
  delivery_status: string;
  tracking_link: string;
}
export interface IGoldOrderStatus {
  created_at: string;
  payment_status: string;
  realization_status: string;
  status: string;
}
export interface IVerifyGoldPrice {
  txn_id: number;
  rate_id: string;
  sg_rate: number;
  partner_rate: number;
  gold_amount: string;
  buy_price: string;
  pre_gst_buy_price: number;
  gst_amount: number;
  user_id: string;
}
export interface IVerifySellPrice {
  txn_id: number;
  rate_id: string;
  gold_amount: string;
  sell_price: string;
  rate: string;
}
export interface IBankAccount {
  beneficiaryName: string;
  bankName: string;
  ifsc: string;
  accountNumber: string;
  verifiedAt: number;
  bankRRN: string;
}
export interface IBankAccountDetails {
  bankAccount: IBankAccount;
  isPanVerified: boolean;
  panNameMatch: boolean;
}
export interface IEgoldUserDetails {
  email: string;
  mobile: string;
  vendor_id: number;
  pin_code: number;
  user_id: number;
  vendor: string;
  is_kyc_verified: boolean;
  bankAccountDetails: IBankAccountDetails;
}
export interface IToastDetails {
  bgColor: string;
  msg: string;
}

export enum LoginChannel {
  WEB = "WEB",
  WEB_V2 = "WEB_V2",
  WEB_V3 = "WEB_V3",
  ANDROID = "ANDROID",
  ANDROID_V2 = "ANDROID_V2",
  ANDROID_V3 = "ANDROID_V3",
}

export enum IOppSubstatus {
  WORK_ADDR_MISMATCH = "WORK_ADDR_MISMATCH",
  PERM_ADDR_MISMATCH = "PERM_ADDR_MISMATCH",
  PAN_UNCLEAR = "PAN_UNCLEAR",
  SELFIE_UNCLEAR = "SELFIE_UNCLEAR",
  AADHAAR_UNCLEAR = "AADHAAR_UNCLEAR",
  CURR_ADDR_PROOF_REQUESTED = "CURR_ADDR_PROOF_REQUESTED",
  CHEQUE_UNCLEAR = "CHEQUE_UNCLEAR",
  KYC_PENDING = "KYC_PENDING",
  PA_FORM_PENDING = "PA_FORM_PENDING",
  SHUBHSIGN_PENDING = "SHUBHSIGN_PENDING",
  APPOINTMENT_PENDING = "APPOINTMENT_PENDING",
  REPAY_INST_PENDING = "REPAY_INST_PENDING",

}

export enum IDocumentSubstatus {
  PAN_UNCLEAR = "PAN_UNCLEAR",
  SELFIE_UNCLEAR = "SELFIE_UNCLEAR",
  AADHAAR_UNCLEAR = "AADHAAR_UNCLEAR",
  CURR_ADDR_PROOF_REQUESTED = "CURR_ADDR_PROOF_REQUESTED",
}

export enum IRequiredPhysicalDocs {
  SIGNED_CHEQUE = "SIGNED_CHEQUE",
  CURR_ADDR_PROOF = "CURR_ADDR_PROOF",
}
